<template >
  <div>
    <div class="bg-gray">
      <div class="container bg-gray">
        <div class="row">
          <div class="col-6 mb-4 text-center round"  @click="answer('TRUE')" :class="{no_active: result == 'cross' }">
            <span class="circle py-3" ></span>
          </div>
          <div class="col-6 mb-4 text-center cross" @click="answer('FALSE')" :class="{no_active: result == 'round'}">
            <h1 class="mt-10 size-50" >×</h1>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    gt: undefined,
    id: undefined
  },
  data () {
    return {
      is_ans: false,
      result: "",
    }
  },
  methods: {
    answer(val){
      if(this.is_ans == false){
        this.is_ans = true
        if (val == 'TRUE' || val == 'True' || val == "true") {
          this.result = 'round'
        }else{
          this.result = "cross"
        }
        if(this.id == undefined){
          this.$emit('setAnswer', val)
        }else{
          this.$emit('setSample', val, this.id)
        } 
      }
    },
  },
  mounted(){
    if(this.gt != undefined){
      if(this.gt == 'TRUE' || this.gt == 'True' || this.gt == "true") {
        this.result = 'round'
      }else{
        this.result = "cross"
      }
    }
  }
}
</script>

<style scoped lang="scss">
.round{
  background: #00A6E1;
  height: 80px;
}
.cross{
  background: #F05096;
  height: 80px;
  color: #FFFFFF;
}
.circle{
  display: inline-block;
  width: 40px;
  height: 40px;
  text-align:center;
  line-height: 80px;
  border-radius: 50%;
  border: solid 5px #FFFFFF;
  margin: 20px auto;
}
.mt-10{
  margin-top: 5px;
}
.size-50{
  font-size: 50px;
}
.no_active{
  background: rgba(1, 1, 20, 0.12) !important;
}

</style>
